import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
  EddyAutoComplete,
  Produto, Login, FuncaoService, GlobalService, SubGrupoSubElementoEstoque, GrupoEstoque
} from 'eddydata-lib';
import { SubGrupoSubElementoEstoqueService } from 'almoxarifado-lib';
import { DespesaService } from 'administrativo-lib';
import * as toastr from 'toastr';

@Component({
  selector: 'lib-sub-grupo-sub-elemento',
  templateUrl: './sub-grupo-sub-elemento.component.html'
})
export class SubGrupoSubElementoComponent implements OnInit, OnChanges, OnDestroy {

  public itemAtual: SubGrupoSubElementoEstoque;
  public despesaAutoComplete: EddyAutoComplete<SubGrupoSubElementoEstoque>;
  protected unsubscribe: Subject<void> = new Subject();

  @Input() lista: Array<any>;
  @Output() listaChange: EventEmitter<any> = new EventEmitter();
  @Input() login: Login;
  @Input() grupo: GrupoEstoque;

  @ViewChild('btnAdicionar') public btnAdicionar: ElementRef;

  constructor(
    protected funcaoService: FuncaoService,
    protected subGrupoSubElementoService: SubGrupoSubElementoEstoqueService,
    protected despesaService: DespesaService,
    protected globalService: GlobalService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.grupo)
      this.carregarAutoCompletes();
  }

  ngOnInit() { }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  private verificarGrupo(): boolean {
    console.log(this.grupo)
    if (!this.grupo) {
      toastr.warning('Necessario informar grupo de estoque!');
      return false;
    }
    if (!this.grupo.elementos || this.grupo.elementos.length === 0) {
      toastr.warning('Grupo de estoque não possui elementos de despesa!');
      return false;
    }
    return true;
  }

  public adicionar() {
    if (!this.verificarGrupo())
      return;
    this.itemAtual = new SubGrupoSubElementoEstoque();
    this.itemAtual.editavel = true;
    if (!this.lista) {
      this.lista = [];
    }
    this.lista.unshift(this.itemAtual);
    this.btnAdicionar.nativeElement.disabled = true;
    this.change();
  }

  public salvar(item: SubGrupoSubElementoEstoque) {
    try {
      if (!this.verificarGrupo())
        return;
      if (!item.sub_elemento) {
        throw new Error('Informe o sub elemento vinculado!');
      }
      // envia a entidade para ser salva no banco -----
      this.btnAdicionar.nativeElement.disabled = false;
      this.itemAtual.editavel = false;
      this.change();
    } catch (e) {
      toastr.warning(e.message);
      throw e;
    }
  }

  public editar(item: SubGrupoSubElementoEstoque) {
    if (!this.verificarGrupo())
      return;
    this.itemAtual = item;
    this.itemAtual.editavel = true;
    this.btnAdicionar.nativeElement.disabled = true;
    this.change();
  }

  public cancelar(item: SubGrupoSubElementoEstoque) {
    this.itemAtual = item;
    if (!this.itemAtual.sub_elemento && !this.itemAtual.id) {
      this.lista.splice(this.lista.findIndex((itm) => { return itm === item }), 1);
    } else {
      this.itemAtual.editavel = false;
    }
    this.btnAdicionar.nativeElement.disabled = false;
    this.change();
  }

  public remover(item: SubGrupoSubElementoEstoque) {
    if (item.id) {
      this.subGrupoSubElementoService.remover(item.id).pipe(takeUntil(this.unsubscribe))
        .subscribe((res) => {
          toastr.success('Registro removido com sucesso!');
          this.lista.splice(this.lista.findIndex((itm) => { return itm === item }), 1);
          this.change();
        }, (error) => toastr.error(error.error.payload));
    } else
      this.lista.splice(this.lista.findIndex((itm) => { return itm === item }), 1);
    this.btnAdicionar.nativeElement.disabled = false;
  }

  private carregarAutoCompletes() {
    if (this.grupo && this.grupo.elementos)
      this.despesaAutoComplete = new EddyAutoComplete(null, this.despesaService,
        'id', ['codigo', 'nome'], {
        'exercicio.id': this.login.exercicio.id,
        OR: this.grupo.elementos.map((e) => `codigo$like=${e.elemento.codigo.substring(0, 6)}%`).join(','),
        orderBy: 'codigo', nivel: 5
      }, { number: ['codigo'], text: ['nome'] }
      );
  }

  private change() {
    this.listaChange.emit(this.lista);
  }

}
